var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-news"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('pressrelase')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-title"},[_vm._v(" 企业服务平台"),_c('span',[_vm._v("新闻")]),_vm._v("动态 "),_c('p',[_vm._v("为您提供行业资讯、活动公告、产品发布，汇聚最前沿流行的云计算技术")])])
}]

export { render, staticRenderFns }